// 国传
import service from "@/tools/request";
import defaultRequestErrorHandle from "@/plug/request/defaultErrorHandle";
export function getGcPatientReportList({
  institution_id,
  type,
  code,
  token,
  check,
  checkcode,
  must
}) {
  return service({
    url: "/getGcPatientReportList",
    method: "post",
    data: {
      institution_id,
      type,
      code,
      token,
      check,
      checkcode,
      must
    },
  }).catch(defaultRequestErrorHandle);
}
export function getGcPatientInfo({ exam_id }) {
  return service({
    url: "/getGcPatientInfo",
    method: "post",
    data: {
      exam_id,
    },
  }).catch(defaultRequestErrorHandle);
}
